/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */


!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});



function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

document.addEventListener("DOMContentLoaded", (event) => {
  $(document).on('click',function(e){
    var _target = $(e.target);
    var status = true;
    if($('.mega-menu.active').length > 0){
      if(_target.closest('.mega-menu__inner').length > 0){
        status = false;
      }else if(_target.closest('.menu-offer-image-wrapper').length > 0){
        status = false;
      }
      if((_target.closest('.Has-dropdown').length > 0 || _target.hasClass('Has-dropdown') == true) && status == true){
        status = false;
      }
    }
    if(status == true){
      $('.mega-menu.active .mega-menu-exit').click();
    }
  });
});


$(document).ready(function () {
  //   $(document).on("click", function(e) {
  //     if ($(e.target).is('.mega-menu') === true ) {
  //       console.log('in');
  //       $('.mega-menu').removeClass('active');
  //         $('.nav-bar__item').removeClass('active');
  //     }
  //   });


  /* Product page BBQ accessories */
  $(document).on('click','.variant-dropdown .variant-swatch-dp .variant-swatch-title',function(e){
    e.preventDefault();
    $(this).closest('.variant-swatch-dp').toggleClass('active');
  });
  //click outside close list dropdown
  $('body').on("click", function(e) {
    if($(e.target).closest('body').find('.variant-dropdown .variant-swatch-dp.active').length || $(e.target).closest('.product_tags.active').length){
      if ($(e.target).is('.variant-dropdown .variant-swatch--options') === false) {
        $('.variant-dropdown .variant-swatch-dp').removeClass('active');
      }
    }
    
    if( $('.nav-bar__item.active').length > 0 ){
      if($(e.target).closest('.nav-bar__item').length == 0){
        $('.nav-bar__item.active .nav-dropdown').attr('aria-hidden', 'true');
        $('.nav-bar__item.active').removeClass('active');        
      }
    }
    
  });
  /* Product page BBQ accessories End */

  $(".line-item--stack .services-list").each(function () {
    if ($(this).children().length > 0) {
      $(this).closest(".additional-services").removeClass("hide");
    }
  });

  $(document).on("click", ".see_more", function () {
    $(this).closest(".applicable_text").find(".More_description").hide();
    $(this).closest(".applicable_text").find(".Less_description").show();
    //var height_less = $(this).closest(".applicable_text").outerHeight();
    //$(this).closest(".flickity-viewport").css("height", height_less + "px");
    $('.applicable_carousel').flickity('resize');
  });
  $(document).on("click", ".see_less", function () {
    $(this).closest(".applicable_text").find(".Less_description").hide();
    $(this).closest(".applicable_text").find(".More_description").show();
    //var height_less = $(this).closest(".applicable_text").outerHeight();
    //$(this).closest(".flickity-viewport").css("height", height_less + "px");
    $('.applicable_carousel').flickity('resize');
  });

  $(document).on("click", ".P_show", function () {
    $(this).closest(".product_short_desc").find(".More_description").hide();
    $(this).closest(".product_short_desc").find(".Less_description").show();
  });
  $(document).on("click", ".P_less", function () {
    $(this).closest(".product_short_desc").find(".Less_description").hide();
    $(this).closest(".product_short_desc").find(".More_description").show();
  });

  $(document).on("click", ".D_show", function () {
    $(this).closest(".pro-content").find(".More_description").hide();
    $(this).closest(".pro-content").find(".Less_description").show();
  });
  $(document).on("click", ".D_less", function () {
    $(this).closest(".pro-content").find(".More_description").show();
    $(this).closest(".pro-content").find(".Less_description").hide();
  });



  /* megamenu js Ryan start */

  (function ($) {
    $.fn.hasScrollBar = function () {
      return this.get(0).scrollHeight > this.height();
    };
  })(jQuery);

  $(".mega-menu__column > .mega-menu-link > .mega-menu__title").on(
    "mouseover",
    function () {
      if ($(this).hasClass("active")) {
        $(this)
          .closest(".mega_menu_cover")
          .find(".mega-menu__title")
          .removeClass("active");
      } else {
        $(this)
          .closest(".mega_menu_cover")
          .find(".mega-menu__title")
          .removeClass("active");
        $(this).addClass("active");
      }

      if (
        $(this)
          .closest(".mega-menu__column")
          .find(".child-lavel .child-lavel-menu ul").length > 0 &&
        $(this)
          .closest(".mega-menu__column")
          .find(".child-lavel .child-lavel-menu ul")
          .get(0).scrollHeight >
          $(this)
            .closest(".mega-menu__column")
            .find(".child-lavel .child-lavel-menu")
            .height()
      ) {
        $(this)
          .closest(".mega-menu__column")
          .find(".child-lavel")
          .addClass("has-scrollable").addClass("scrollabled");
      } else {
        $(this)
          .closest(".mega-menu__column")
          .find(".child-lavel")
          .removeClass("has-scrollable");
      }
    }
  );

  $(document).on(
    "click",
    ".nav-bar__linklist .nav-bar__item.nav-bar__item--static",
    function () {
      if ($(this).hasClass("active")) {
        var chkheight = $(this)
          .find(
            ".mega_menu_cover .mega-menu__column:first-child .child-lavel .child-lavel-menu"
          )
          .height();
        if (
          $(this).find(
            ".mega_menu_cover .mega-menu__column:first-child .child-lavel .child-lavel-menu ul"
          ).length > 0
        ) {
          var chkscrollheight = $(this)
            .find(
              ".mega_menu_cover .mega-menu__column:first-child .child-lavel .child-lavel-menu ul"
            )
            .get(0).scrollHeight;
          if (chkscrollheight > chkheight) {
            $(this)
              .find(
                ".mega_menu_cover .mega-menu__column:first-child .child-lavel"
              )
              .addClass("has-scrollable");
          }
        }
      }
    }
  );
  
  var hasPreviousHeight = 0;
  $(".mega-menu-link .mega-menu__title").on("mouseover", function () {
    var element = $(this);
    element
      .closest(".mega-menu")
      .find(".menu-offer-image-wrapper .menu-offer-block .Image_promo_wrap")
      .addClass("hide");
    var store_handle = element.attr("data-handle");
    
    if( hasPreviousHeight > 0 ){
      element.closest('.mega-menu__inner').css('min-height', `${hasPreviousHeight}px`);
      element.closest('.mega-menu__inner').next().css('min-height', `${hasPreviousHeight}px`);
    }
    element
      .closest(".mega-menu")
      .find(".menu-offer-image-wrapper .menu-offer-block .Image_promo_wrap")
      .each(function () {
        var temp_handle = $(this).attr("data-handle");
        var temp_ele = $(this);
        if (temp_handle == store_handle) {
          $(this).removeClass("hide");          
          if($(this).find('.img-item img.img-loaded').length || $(this).find('.lazyloaded').length){
            var h = $(temp_ele).outerHeight(true);
            element.closest('.mega-menu__inner').css('min-height', `${ h }px`);
            element.closest('.mega-menu__inner').next().css('min-height', `${ h }px`);
            hasPreviousHeight = h > hasPreviousHeight ? h : hasPreviousHeight;            
          }else{
            $(this).find('.img-item img').one("load", function() {              
              var h = $(temp_ele).outerHeight(true);
              $(this).addClass('img-loaded')
              element.closest('.mega-menu__inner').css('min-height', `${h}px`);
              element.closest('.mega-menu__inner').next().css('min-height', `${ h }px`);
              hasPreviousHeight = h > hasPreviousHeight ? h : hasPreviousHeight;
            }).each(function() {if(this.complete) {}});
          }
        }
      });
    console.log('hasPreviousHeight', hasPreviousHeight);

    if (
      element
        .closest(".mega-menu__column")
        .find(".child-lavel")
        .hasClass("open")
    ) {
      element.removeClass("open");
    } else {
      element
        .closest(".mega-menu__column")
        .find(".mega-menu__title")
        .removeClass("open");
      element
        .closest(".mega_menu_cover")
        .find(".child-lavel")
        .removeClass("open");
      element
        .closest(".mega-menu__column")
        .find(".child-lavel")
        .addClass("open");
    }
  });

  $(".mega-menu-exit").on("click", function () {
    $(this).closest(".nav-bar__item").find(".mega-menu").removeClass("active");
    $(this).closest(".nav-bar__item").removeClass("active");
  });

  if ($(".menu-offer-image-wrapper").hasClass("with-promo-offer")) {
    $(".menu-offer-image-wrapper.with-promo-offer")
      .closest(".container")
      .find(".child-lavel")
      .addClass("no-exit-btn");
  }

  //   $(document).on('click', function(event) {
  //     if (!$(event.target).closest('.mega-menu').length)  {
  //       $('.nav-bar__item').find('.mega-menu').removeClass("active");
  //       $('.nav-bar__item').removeClass("active");
  //     }
  //   });

  /* megamenu js Ryan end */

  //   $('.mega-menu-link .mega-menu__title').on('click', function() {
  //     $(this).closest('.mega-menu__column').find('.child-lavel').addClass('open');
  //   });

  if ($(window).width() < 1000) {
    $(".header__mobile-nav-toggle").on("click", function () {
      $("#shopify-section-header").toggleClass("sticky-header");
      $("html").toggleClass("overflow-hide");
    });
  }

  $(".product_tabs_inner .tab-content").eq(0).addClass("current");

  $(".product_tabs_inner .tabs .tab-link").eq(0).addClass("current");

  $(".color-swatch1 a").click(function (e) {
    e.preventDefault();
    var curr = $(this);
    curr
      .closest(".color-swatch-list1")
      .find(".color-swatch1")
      .each(function () {
        if ($(this).find("a").hasClass("active")) {
          $(this).find("a").removeClass("active");
        }
      });
    $(this).addClass("active");

    var pdpURL = $(this).attr("href");
    $.getJSON(pdpURL + ".js", function (data) {
      var featuredImg = data.featured_image;
      var imgtitle = data.title;
      var url_p = data.url;
      curr
        .closest(".product-item")
        .find(".product-item__image-wrapper ")
        .attr("href", url_p);
      curr
        .closest(".product-item")
        .find(".product-item__image-wrapper img")
        .attr("srcset", featuredImg);
      curr
        .closest(".product-item__info-inner")
        .find(".product-item__title")
        .text(imgtitle);
    });
  });

  $(".block-swatch1 a").click(function (e) {
    e.preventDefault();
  });

  $(".footer__aside-item--links span.links").on("click", function () {
    if ($(this).attr("target") == "_blank") {
      window.open($(this).data("url"));
    } else {
      location.href = $(this).data("url");
    }
  });

  $(".team-more-info").magnificPopup({
    type: "inline",
    preloader: false,
    focus: "#username",
    modal: false,
  });

  var applicableContainerLength = Number($('.applicable_carousel').attr('data-size'));
  if(applicableContainerLength > 1){
    $('.applicable_carousel').flickity({
      "prevNextButtons": true,
      "pageDots": false,
      "wrapAround": false,
      "contain": true,
      "cellAlign": "left"
    });
    $('.applicable_carousel').on( 'select.flickity', function(event, index) {
      var appCurrentSlide = index + 1;
      var appTotalSlide = $('.applicable_carousel .flickity-slider .applicable-main-wrapper').length;
      $('.applicable_part .app-carousel-status').text(appCurrentSlide + '/' + appTotalSlide);
    });
  }

  $(document).on('click', '[data-applicable-offer-lable]', function(e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: $(".mid-all-features-wrapper #applicable_part_section").offset().top - 145
    },900);
  });

  if ($(window).width() > 767) {
    $(".pro-catagory-itmes").flickity({
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      contain: true,
      cellAlign: "left",
      watchCSS: true,
    });
  }

  //   $('.brand-mega-menu-sidebar ul li a').hover(function(){
  //     console.log($(this).data('tag'));
  //   });

  $(".mobile-brand .mobile-menu__nav-link").on("click", function () {
    var tag_name = $(this).attr("aria-controls");
    var _tag_name = tag_name.replace(/ /g, "");
    var f_char_mobile = _tag_name.substring(0, 1);
    var l__char_mobile = _tag_name.substring(2);
    var s_first_char_mobile = f_char_mobile.toLowerCase();
    var s_last_char_mobile = l__char_mobile.toLowerCase();
    $("#" + tag_name)
      .find(".mobile-menu__nav .mobile-menu__nav-item.chk-hide")
      .each(function () {
        $(this).addClass("hide");
      });

    $("#" + tag_name)
      .find(".mobile-menu__nav .mobile-menu__nav-item.hide")
      .each(function () {
        var check_char_mobile = $(this).find("a").attr("data-tags");
        var check_num_mobile = check_char_mobile.charCodeAt(0);
        for (
          let count_1 = s_first_char_mobile.charCodeAt(0);
          count_1 < s_last_char_mobile.charCodeAt(0);
          count_1++
        ) {
          if (count_1 == check_num_mobile) {
            $(this).removeClass("hide");
          }
        }
        for (
          let count_1 = f_char_mobile.charCodeAt(0);
          count_1 <= l__char_mobile.charCodeAt(0);
          count_1++
        ) {
          if (count_1 == check_num_mobile) {
            $(this).removeClass("hide");
          }
        }
      });
  });

  //   $(".brand-mega-menu-sidebar ul li a").on("click", function(){
  //     $(this).closest('ul').find('li.active').removeClass('active');
  //     $(this).parent().addClass('active');
  //     var title_set = $(this).data('tag');
  //     $(this).closest('.brand-mega-menu-list').find('.brand-mega-menu-content .mega_menu_top_title h4').text(title_set);
  //     if(title_set == 'All'){
  //     	$('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item a').css('display','block');
  //         $(this).addClass('show');
  //     }
  //     else{
  //     	$('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item a').css('display','none');
  //       $('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item').removeClass('show');
  //       if(title_set == $('.first-portion').attr('data-tag')){
  //         $('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item').each(function(){
  //           var _tag = $('.first-portion').attr('data-tag').replace(/ /g,'');
  //           var f_char_1 = _tag.substring(0, 1);
  //           var l__char_1 = _tag.substring(2);
  //           var s_first_char_1 = f_char_1.toLowerCase();
  //           var s_last_char_1 = l__char_1.toLowerCase();
  //           var check_char_1 = $(this).find('a').attr('data-tags');
  //           var check_num_1 = check_char_1.charCodeAt(0);
  //           for (let count_1 = s_first_char_1.charCodeAt(0); count_1 <= s_last_char_1.charCodeAt(0); count_1++) {
  //             if(count_1 == check_num_1){
  //             	$(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //             }
  //           }
  //           for (let count_1 = f_char_1.charCodeAt(0); count_1 <= l__char_1.charCodeAt(0); count_1++) {
  //             if(count_1 == check_num_1){
  //             	$(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //             }
  //           }
  //         });
  //       }
  //       else if(title_set == $('.second-portion').attr('data-tag')){
  //         $('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item').each(function(){
  //           var _tag = $('.second-portion').attr('data-tag').replace(/ /g,'');
  //           var f_char_2 = _tag.substring(0, 1);
  //           var l__char_2 = _tag.substring(2);
  //           var s_first_char_2 = f_char_2.toLowerCase();
  //           var s_last_char_2 = l__char_2.toLowerCase();
  //           var check_char_2 = $(this).find('a').attr('data-tags');
  //           var check_num_2 = check_char_2.charCodeAt(0);
  //           for (let count_2 = s_first_char_2.charCodeAt(0); count_2 <= s_last_char_2.charCodeAt(0); count_2++) {
  //             if(count_2 == check_num_2){
  //             	$(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //             }
  //           }
  //           for (let count_2 = f_char_2.charCodeAt(0); count_2 <= l__char_2.charCodeAt(0); count_2++) {
  //             if(count_2 == check_num_2){
  //             	$(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //             }
  //           }
  //         });

  //       }
  //       else if(title_set == $('.third-portion').attr('data-tag')){
  //       	$('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item').each(function(){
  //           var _tag = $('.third-portion').attr('data-tag').replace(/ /g,'');
  //           var f_char_3 = _tag.substring(0, 1);
  //           var l__char_3 = _tag.substring(2);
  //           var s_first_char_3 = f_char_3.toLowerCase();
  //           var s_last_char_3 = l__char_3.toLowerCase();
  //           var check_char_3 = $(this).find('a').attr('data-tags');

  //           if(check_char_3 == 'T' || check_char_3 == 't'){
  //             if($(this).find('a').text().trim() != 'TA Appliances & Barbecues'){
  //               var check_num_3 = check_char_3.charCodeAt(0);
  //               for (let count_3 = s_first_char_3.charCodeAt(0); count_3 <= s_last_char_3.charCodeAt(0); count_3++) {
  //                 if(count_3 == check_num_3){
  //                   $(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //                 }
  //               }
  //               for (let count_3 = f_char_3.charCodeAt(0); count_3 <= l__char_3.charCodeAt(0); count_3++) {
  //                 if(count_3 == check_num_3){
  //                   $(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //                 }
  //               }
  //             }
  //           }
  //           else{
  //             var check_num_3 = check_char_3.charCodeAt(0);
  //             for (let count_3 = s_first_char_3.charCodeAt(0); count_3 <= s_last_char_3.charCodeAt(0); count_3++) {
  //               if(count_3 == check_num_3){
  //                 $(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //               }
  //             }
  //             for (let count_3 = f_char_3.charCodeAt(0); count_3 <= l__char_3.charCodeAt(0); count_3++) {
  //               if(count_3 == check_num_3){
  //                 $(this).find('a').css('display','block');
  //                 $(this).addClass('show');
  //               }
  //             }
  //           }

  //         });
  //       }
  //     }
  //   });

  $(".mobile-menu__nav-link").on("click", function () {
    $("#shop-by-brand .mobile-menu__nav li").each(function () {
      if ($(this).find("button").attr("aria-expanded") == "true") {
        $(this).find("button").trigger("click");
      }
      //     	$(this).find('button').trigger('click');
    });
  });

  $(".brand-menu-mobile .mobile-menu__nav .mobile-menu__nav-list-toggle").on(
    "click",
    function () {
      var check_data = $(this).attr("aria-expanded");
      var check_name = $(this).attr("aria-controls");
      if (check_data == "false") {
        //       $(this).parent().find('.mobile-menu__nav-collapsible .mobile-menu__nav-item a').css('display','none');

        var f_char_1 = check_name.substring(0, 1);
        var l__char_1 = check_name.substring(2);
        var s_first_char_1 = f_char_1.toLowerCase();
        var s_last_char_1 = l__char_1.toLowerCase();

        $(
          ".mobile-menu__nav-collapsible[id=" +
            check_name +
            "] .mobile-menu__nav-item"
        ).each(function () {
          $(this).find("a").css("display", "none");

          var check_char_1 = $(this).find("a").attr("data-tags");
          var check_num_1 = check_char_1.charCodeAt(0);
          //         console.log(check_char_1);

          for (
            let count_1 = s_first_char_1.charCodeAt(0);
            count_1 < s_last_char_1.charCodeAt(0);
            count_1++
          ) {
            if (count_1 == check_num_1) {
              $(this).find("a").css("display", "block");
            }
          }
          for (
            let count_1 = f_char_1.charCodeAt(0);
            count_1 < l__char_1.charCodeAt(0);
            count_1++
          ) {
            if (count_1 == check_num_1) {
              $(this).find("a").css("display", "block");
            }
          }
        });

        //       if(check_name == $('.mobile-menu__nav li:eq(0) .mobile-menu__nav-collapsible').attr('id')){
        //         $(this).parent().find('.mobile-menu__nav-collapsible .mobile-menu__nav-item').each(function(){

        //           var f_char_1 = check_name.substring(0, 1);
        //           var l__char_1 = check_name.substring(2);
        //           var s_first_char_1 = f_char_1.toLowerCase();
        //           var s_last_char_1 = l__char_1.toLowerCase();
        //           var check_char_1 = $(this).find('a').attr('data-tags');
        //           var check_num_1 = check_char_1.charCodeAt(0);

        //           console.log(f_char_1,l__char_1,s_first_char_1,s_last_char_1,check_char_1,check_num_1);

        //           for (let count_1 = s_first_char_1.charCodeAt(0); count_1 < s_last_char_1.charCodeAt(0); count_1++) {
        //             if(count_1 == check_num_1){
        //             	$(this).find('a').css('display','block');
        //             }
        //           }
        //           for (let count_1 = f_char_1.charCodeAt(0); count_1 < l__char_1.charCodeAt(0); count_1++) {
        //             if(count_1 == check_num_1){
        //             	$(this).find('a').css('display','block');
        //             }
        //           }
        //         });
        //       }
        //       else if(check_name == $('.mobile-menu__nav li:eq(1) .mobile-menu__nav-collapsible').attr('id')){
        //       	$(this).parent().find('.mobile-menu__nav-collapsible .mobile-menu__nav-item').each(function(){
        //           var check_char_mobile = $(this).find('a').attr('data-tags');
        //           var check_num_mobile = check_char_mobile.charCodeAt(0);
        //           for (let count = 106; count < 116; count++) {
        //             if(count == check_num_mobile){
        //             	$(this).find('a').css('display','block');
        //             }
        //           }
        //           for (let count = 74; count < 84; count++) {
        //             if(count == check_num_mobile){
        //             	$(this).find('a').css('display','block');
        //             }
        //           }
        //         });
        //       }
        //       else if(check_name == $('.mobile-menu__nav li:eq(2) .mobile-menu__nav-collapsible').attr('id')){
        //       	$(this).parent().find('.mobile-menu__nav-collapsible .mobile-menu__nav-item').each(function(){
        //           var check_char_mobile = $(this).find('a').attr('data-tags');
        //           var check_num_mobile = check_char_mobile.charCodeAt(0);
        //           for (let count = 116; count < 123; count++) {
        //             if(count == check_num_mobile){
        //             	$(this).find('a').css('display','block');
        //             }
        //           }
        //           for (let count = 84; count < 87; count++) {
        //             if(count == check_num_mobile){
        //             	$(this).find('a').css('display','block');
        //             }
        //           }
        //         });
        //       }
        //       else{
        //       	$(this).parent().find('.mobile-menu__nav-collapsible .mobile-menu__nav-item a').css('display','block');
        //       }
      }
    }
  );

  $(".nav-bar__item .nav-bar__link.Has-dropdown").on("click", function (e) {
    e.preventDefault();
    var parentElement = $($(this).parent());
    if (parentElement.hasClass("active")) {
      var find_class = $(this).find(".mega-menu.brand-mega-menu");
      if (find_class.length > 0) {
        parentElement.removeClass("active");
        $(".mega-menu").removeClass("active");
        $(this)
          .parent()
          .find(".nav-dropdown")
          .first()
          .attr("aria-hidden", "true");
        $(".mega-menu.brand-mega-menu").attr("aria-hidden", "true");
      } else {
        parentElement.removeClass("active");
        $(".mega-menu").removeClass("active");
        $(this)
          .parent()
          .find(".nav-dropdown")
          .first()
          .attr("aria-hidden", "true");
      }
    } else {
      $(".nav-bar__linklist .nav-bar__item").each(function () {
        $(this).removeClass("active");
      });

      $(".nav-dropdown").attr("aria-hidden", "true");

      $(".mega-menu").removeClass("active");

      parentElement.find('.mega-menu__title.active').trigger('mouseover');
      parentElement.addClass("active");
      var find_length = parentElement.find(".mega-menu");
      if (find_length.length) {
        parentElement.find(".mega-menu").addClass("active");
      } else {
        $(this)
          .parent()
          .find(".nav-dropdown")
          .first()
          .attr("aria-hidden", "false");
      }
    }

    //     $('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item a').css('display','none');
    $(
      ".brand-mega-menu-content .mega-menu__linklist .mega-menu__item"
    ).removeClass("show");
    if (
      $(this).closest(".nav-bar__item").find(".mega-menu.brand-mega-menu")
        .length > 0
    ) {
      $(this)
        .closest(".nav-bar__item")
        .find(
          ".mega-menu.brand-mega-menu .brand-mega-menu-content .mega_menu_top_title h4"
        )
        .text(
          $(this)
            .closest(".nav-bar__item")
            .find(
              ".mega-menu.brand-mega-menu .brand-mega-menu-sidebar ul li:eq(0) a"
            )
            .data("tag")
        );
    }

    $(this)
      .closest(".nav-bar__item")
      .find(".brand-mega-menu-sidebar ul li.active")
      .removeClass("active");
    $(this)
      .closest(".nav-bar__item")
      .find(".brand-mega-menu-sidebar ul li:eq(0)")
      .addClass("active");
    //     $('.brand-mega-menu-content .mega-menu__linklist .mega-menu__item').each(function(){
    //       var check_char_curr = $(this).find('a').attr('data-tags');
    //       var check_num_curr = check_char_curr.charCodeAt(0);
    //       for (let count_check = 97; count_check <= 100; count_check++) {
    //         if(count_check == check_num_curr){
    //           $(this).find('a').css('display','block');
    //           $(this).addClass('show');
    //         }
    //       }
    //       for (let count_check = 65; count_check <= 68; count_check++) {
    //         if(count_check == check_num_curr){
    //           $(this).find('a').css('display','block');
    //           $(this).addClass('show');
    //         }
    //       }
    //     });

    if (
      $(this)
        .closest(".nav-bar__item")
        .find(".brand-mega-menu")
        .attr("aria-hidden") == "false"
    ) {
      $(this)
        .closest(".nav-bar__item")
        .find(".brand-mega-menu")
        .attr("aria-hidden", "true");
    } else {
      $(this)
        .closest(".nav-bar__item")
        .find(".brand-mega-menu")
        .attr("aria-hidden", "false");
    }

    //     $('html').click(function(event) {
    //       console.log($(event.target).attr('id'));
    //       if ($(event.target).attr('id') == 'brand_click') {
    //         $(".nav-bar__item").find('.brand-mega-menu').attr('aria-hidden','true');
    //       }
    //     });
    //     $('html').click(function(event) {
    //       if ($(event.target).closest('.nav-bar__item').length === 0) {
    //         $(".nav-bar__item").find('.brand-mega-menu').attr('aria-hidden','true');
    //       }
    //     });

    //     $(this).closest('.nav-bar__item').find('.brand-mega-menu').attr('aria-hidden','false');

    $("html").click(function (event) {
      if (
        !$(event.target).closest("#brand_click").length &&
        !$(event.target).closest(".brand-mega-menu-list").length
      ) {
        $(".nav-bar__item")
          .find(".brand-mega-menu")
          .attr("aria-hidden", "true");
        $(".nav-bar__item").find(".brand-mega-menu").removeClass("active");
      }

      if (
        !$(event.target).closest(".nav-bar__link").length &&
        !$(event.target).closest(".mega-menu").length
      ) {
        $(".nav-bar__item").find(".mega-menu").removeClass("active");
        $(".mega-menu").removeClass("active");
        $(".nav-bar__item").removeClass("active");
      }
    });
  });

  $(document).on("click", ".brand-mega-menu-sidebar ul li a", function () {
    var chk_tag = $(this).attr("data-tag");
    $(".brand-mega-menu-sidebar ul li").removeClass("active");
    $(this).parent().addClass("active");
    $(".mega-menu__inner.child-lavel-menu").addClass("hide");
    $(
      '.mega-menu__inner.child-lavel-menu[data-tag="' + chk_tag + '"]'
    ).removeClass("hide");
  });

  $(".block-swatch .product_tags").on("click", function (e) {
    e.preventDefault();
  });

  $(".variant_selectbox").on("change", function () {
    var curr_val = $(this).val();
    $(".no-js.product-form__option")
      .find("select option")
      .each(function () {
        if (curr_val == $(this).val()) {
          $(".no-js.product-form__option select option").each(function () {
            $(this).removeAttr("selected");
          });
          $(
            ".no-js.product-form__option select option[value=" + curr_val + "]"
          ).attr("selected", "selected");
        }
      });
  });

  $(".bold_cart_edit_button").on("click", function () {
    $(this).closest(".line-item__property-list").addClass("added");
    var this_8 = $(this);
    $(".bold_option_edit_container button").on("click", function () {
      var chk_text = $(this).text().trim();
      if (chk_text == "Cancel") {
        this_8.closest(".line-item__property-list").removeClass("added");
      }
    });
  });

  $(document).on("click", ".block-swatch span", function () {
    var url = $(this).data("url");
    window.location = url;
  });

  $(document).on("click", ".color-swatch-list .color-swatch span", function () {
    var url = $(this).data("url");
    window.location = url;
  });

  $(document).on(
    "click",
    ".pro-variant_wrapper .color-swatch span",
    function () {
      var id = $(this).data("id");
      $(".variant_list .color-swatch").each(function () {
        if ($(this).find("span").hasClass("active")) {
          $(this).find("span").removeClass("active");
        }
      });
      $(this).addClass("active");
      $(this)
        .closest(".pro-content")
        .find(".btn-wrapper span")
        .attr("data-id", id);
    }
  );

  $(document).on("click", ".btn.select-btn", function () {
    var handle = $(this).closest(".zoom-anim-dialog").data("handle");
    var id_new = $(this).attr("data-id");
    $(".acccessories-list .acccessories-item").each(function () {
      if ($(this).attr("data-handle") == handle) {
        if (!$(this).find(".content .checkbox-item input").is(":checked")) {
          $(this).find(".content .checkbox-item input").prop("checked", true);
          $('.product-spec-accordian .complementary_products_part .product-item [data-acc-item][data-id="'+id_new+'"]').prop("checked", true);
          $(this).find(".content .checkbox-item input").attr("data-id", id_new);
        } else {
          $(this).find(".content .checkbox-item input").attr("data-id", id_new);
        }
      }
    });
    $.magnificPopup.close();
  });

  //accessories recomneded product on change event
  $(document).on('change', 'input[type=checkbox][data-acc-item]', function() {
    var crrId  = $(this).attr('data-id');
    if($(this).is(':checked')) {
      $('[data-acc-item][data-id="'+crrId+'"]').prop("checked", true);
    }else{
      $('[data-acc-item][data-id="'+crrId+'"]').prop("checked", false);
    }
  });
  //end

  $(document).on("click", ".data-remove", function () {
    var id = $(this).attr("data-id");
    var timestamp = $(this).closest(".line-item").attr("data-timestamp");
    var sku = $(this).attr("data-sku");
    var update_object = "";
    $.getJSON("/cart.js", function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties.timestamp == timestamp) {
          if (update_object == "") {
            update_object = "updates[" + cart.items[i].id + "]=0";
          } else {
            update_object =
              update_object + "&updates[" + cart.items[i].id + "]=0";
          }
        }
      }
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties.For == sku) {
          update_object =
            update_object + "&updates[" + cart.items[i].id + "]=0";
        }
      }
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: update_object,
        dataType: "json",
        success: function (cart) {
          location.reload();
        },
        error: function () {
          location.reload();
        },
      });
    });
  });

  if (window.ZapietEvent != undefined) {
    window.ZapietEvent.listen("selected_method", function (checkout_method) {
      switch (checkout_method) {
        case "pickup":
          var found_service = false;
          $(".additional-services").each(function () {
            $(this)
              .find(".input-checkbox")
              .each(function () {
                if ($(this).is(":checked")) {
                  found_service = true;
                }
              });
          });

          if (found_service) {
            window.setTimeout(function () {
              $("#storePickupApp .checkoutMethod").eq(0).trigger("click");
            }, 1500);
            alert(
              "You have additional services selected that require delivery.  Remove those services to switch to pickup."
            );
          } else {
            $(".additional-services").hide();
          }
          break;
        case "delivery":
          $(".additional-services").show();
          break;
        case "shipping":
          // Do something when shipping is selected
          break;
      }
    });
  }

  $(".bold_cart_edit_button")
    .mouseenter(function () {
      $(this).parent().find(".additional-tooltip").addClass("open");
    })
    .mouseleave(function () {
      $(this).parent().find(".additional-tooltip").removeClass("open");
    });

  setTimeout(function () {
    if ($(".bold_options").length > 0) {
      $(".bold_options .bold_option_title").append(
        '<a href="/pages/protection-plan"><span class="tooltip">  <img src="//cdn.shopify.com/s/files/1/0551/1390/8403/t/25/assets/info.png?v=11449799930962743458"><span class="tooltip-text">TA Protection Plan<br>Click to learn more</span></span></a>'
      );
    }
  }, 1500);

  $('[data-action="add-to-cart2"]').on("click", function (e) {
    e.preventDefault();

    var _this7 = $(this);

    var status = false;
    var counter = false;
    var curr_handle = $(this)
      .closest("main")
      .find(".card__section form .pro_handle")
      .val();
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    var isALARendered;
    function ALAcheck() {
      isALARendered = setInterval(function () {
        customALA();
      }, 2000);
    }
    ALAcheck();
    function customALA() {
      if (counter == true) {
        clearInterval(isALARendered);

        if (status == true) {
          var target = _this7;
          target.attr("disabled", "disabled");
          var time_stamp = $(
            ".product-block-list__item--info form .pro_timestamp"
          ).val();
          console.log(time_stamp, "time_stamp");
          target
            .closest("form")
            .append(
              '<input type="hidden" name="properties[_timestamp]" value="' +
                time_stamp +
                '">'
            );
          var data = target.parents("form").serialize();
          // Then we add the product in Ajax

          $.ajax({
            type: "POST",
            data: data,
            dataType: "json",
            url: "/cart/add.js",
            success: function (cart) {
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              document.documentElement.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    quantity: 1,
                  },
                })
              );
              target.removeAttr("disabled", "disabled");
            },
            error: function (cart) {
              console.log("error");
            },
          });
        } else {
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        }
      }
      $.getJSON("/cart.js", function (cart) {
        if (cart.items.length > 0) {
          for (var l = 0; l < cart.items.length; l++) {
            if (cart.items[l].handle == curr_handle) {
              status = true;
            }
          }
          counter = true;
        } else {
          counter = true;
        }
      });
    }
  });

  $(".button-locations").on("click", function (e) {
    e.preventDefault();
    var location = $(this).attr("href");
    if ($(this).attr("target") == "_blank") {
      window.open(location);
    } else {
      window.location.replace(location);
    }
  });

  $(".addresses .store_website a").on("click", function (e) {
    e.preventDefault();
    var location = $(this).attr("href");
    window.location.replace(location);
  });


  //scroll evet
  $(window).scroll(debounce(function(event) {
    var scrollTop = $(this).scrollTop();
    if(scrollTop > 235){
      $(".nav-bar__item").removeClass("active")
      $(".nav-bar__item .brand-mega-menu").attr("aria-hidden", "true").removeClass("active");
      if($('.mega-menu.active').length > 0){
          $('.mega-menu.active .mega-menu-exit').click();
      }
    }
  },50));
  //scroll evet
  
  
});

function viewall() {
  $('.product_tabs_inner .tabs li[data-tab="tab-5"]').trigger("click");
  $("html, body").animate(
    {
      scrollTop: $(".product_tabs").offset().top,
    },
    1000
  );
}

$(document).ready(function () {
  
  var width = $(window).width();
  if (width <= 640) {
    $(".mobi-slide-img-wrap").each(function () {
      var $this = $(this),
        $img = $this.find("img");

      $img.load(function () {
        var w = $this.find("img").width();
        var h = $this.find("img").height();
        alert("width: " + w + " & height: " + h);
        $this.width(w).height(h);
      });
    });
  }

  //get image hieght of promo banner -- desktop only
  $(".promo-banner-image").each(function () {
    var chk_size = $(this).find(".promo-banner").length;
    if (chk_size > 2) {
      var chk100 = [];
      var chk150 = [];
      $(this)
        .find(".promo-banner")
        .each(function () {
          if ($(this).hasClass("imgsize-100")) {
            chk100.push(100);
          } else {
            chk150.push(150);
          }
        });
      var count100 = chk100.length;
      var count150 = chk150.length;
      if (count150 > count100) {
        $(this)
          .find(".imgsize-100")
          .each(function () {
            $(this).addClass("hide");
          });
      }
      if (count100 > count150) {
        $(this)
          .find(".imgsize-156")
          .each(function () {
            $(this).addClass("hide");
          });
      }
      if (count150 > 2) {
        $(this).find(".imgsize-156:eq(2)").addClass("hide");
      }
    }
  });

  //get image hieght of promo banner -- mobile only
  $(".promo-banner-image-mobile").each(function () {
    var chk_size = $(this).find(".mb-promo-banner").length;
    if (chk_size > 2) {
      var chk100 = [];
      var chk150 = [];
      $(this)
        .find(".mb-promo-banner")
        .each(function () {
          if ($(this).hasClass("imgsize-100")) {
            chk100.push(100);
          } else {
            chk150.push(150);
          }
        });
      var count100 = chk100.length;
      var count150 = chk150.length;
      if (count150 > count100) {
        $(this)
          .find(".imgsize-100")
          .each(function () {
            $(this).addClass("hide");
          });
      }
      if (count100 > count150) {
        $(this)
          .find(".imgsize-156")
          .each(function () {
            $(this).addClass("hide");
          });
      }
      if (count150 > 2) {
        $(this).find(".imgsize-156:eq(2)").addClass("hide");
      }
    }
  });

  //for floor model chekbox JS in product page

  if ($(".product-block-list__item--info .floor-model-wrapper").length > 0) {
    $(".product-block-list__item--info .product-form__add-button").addClass(
      "disabled-chekbox"
    );
    $(
      ".product-block-list__item--info .floor-model-wrapper .checkboxs input"
    ).change(function () {
      if ($(this).is(":checked")) {
        $(this).attr("checked", true);
        $(
          ".product-block-list__item--info .product-form__add-button"
        ).removeClass("disabled-chekbox");
        $(
          '.product-block-list__item--info .floor-model-wrapper .erro-msg:not(".hide")'
        ).addClass("hide");
      } else {
        $(this).attr("checked", false);
        $(".product-block-list__item--info .product-form__add-button").addClass(
          "disabled-chekbox"
        );
        $(
          ".product-block-list__item--info .floor-model-wrapper .erro-msg"
        ).removeClass("hide");
      }
    });
  }

  $(".product-block-list__item--info .product-form__add-button").click(
    function () {
      if ($(this).hasClass("disabled-chekbox")) {
        $(
          ".product-block-list__item--info .floor-model-wrapper .erro-msg"
        ).removeClass("hide");
        return false;
      }
    }
  );
  //END

  
  if($('body.template-product').length){
    //sticky add to cart
    stickyAddToCart();
    //end
  }


  //** APPLIES REWARD DISCOUNT CODE TO THE CHECKOUT PAGE WHEN MINI CART FORM IS SUBMITTED **
  $(document).on('click','#mini-cart [data-has-discount]',function(e){
    e.preventDefault();
    applyRewardDiscountCoupen();
  });
  //** APPLIES REWARD DISCOUNT CODE TO THE CHECKOUT PAGE WHEN MINI CART FORM IS SUBMITTED **
  
});


function stickyAddToCart() {
  $(window).scroll(debounce(function(event) {
    var scrollTop = $(this).scrollTop();    
    if($('body.template-product').length && $('[data-sticky-cart]').length){
      var atcBtn = $('.product-block-list__item .product-form__payment-container').offset().top;
      //console.log('scrollTop--',scrollTop, 'atcBtn--',atcBtn);
      scrollTop >= atcBtn ? $('[data-sticky-cart]').addClass('open') : $('[data-sticky-cart]').removeClass('open');
    }
  },65));
  
  stickyAddToCartQtySelector();
  
  var isProtectionPlanAvl = $('[data-has-protection]').length;
  if(!isProtectionPlanAvl){
    $('[data-sticky-cart] [data-sticky-protection]').html('').addClass('hide');
  }
  //handle add cart click event
  $('[data-sticky-cart] [data-cart-trigger]').on('click',function(e) {
    
    e.preventDefault();
    //console.log('click >>');
    $('.product-block-list__item--info .product-form__add-button').trigger('click');
    if($('.product-block-list__item--info .product-form__add-button').hasClass('disabled-chekbox')){
      $('html, body').animate({
        scrollTop: $('.product-block-list__item--info .floor-model-wrapper').offset().top
      }, 900);
    }
    if($('.product-block-list__item--info .product-form__add-button').hasClass('data-disabled')){
      $('html, body').animate({
        scrollTop: $('.product-block-list__item--info [data-has-protection]').offset().top - 70
      }, 900);
    }
    
  });
  //handle add cart click event end
  
}

function stickyAddToCartQtySelector() {
  let inputElement = document.querySelector('[data-sticky-cart] [name="quantity"]') || null;
  if(!inputElement) return;
  let mainInputAvl = $('.product-block-list [data-main-qty]').length;
  $('[data-sticky-cart] [data-action="decrease-picker-quantity"]').on('click',function(e) {
    e.preventDefault();
    let inpVal = inputElement.value == '' ? inputElement.value = 1 : inputElement.value;
    let dVal = Math.max(1, parseInt(inpVal) - 1);
    inputElement.value = dVal;
    if(mainInputAvl){
      $('.product-block-list .quantity-selector--product button[data-action="decrease-picker-quantity"]').trigger('click');
    }else{
      $('.product-block-list input[name="quantity"]').attr('value',dVal);
    }
  }); 
  $('[data-sticky-cart] [data-action="increase-picker-quantity"]').on('click',function(e) {
    e.preventDefault();
    let inpVal = inputElement.value == '' ? inputElement.value = 1 : inputElement.value;
    let iVal = parseInt(inpVal) + 1;
    inputElement.value = iVal;
    if(mainInputAvl){
      $('.product-block-list .quantity-selector--product button[data-action="increase-picker-quantity"]').trigger('click');
    }else{
      $('.product-block-list input[name="quantity"]').attr('value',iVal);
    }
  }); 
}


function applyRewardDiscountCoupen(){
  let discountCode = document.querySelector('#mini-cart [data-has-discount]').getAttribute('data-has-discount');
  if (discountCode && discountCode != '') {
    // Save the discount code as a session cookie
    document.cookie = `discount_code=${discountCode}; path=/`;
    // Send GET request to "/discount/[discountcode]"
    fetch(`/discount/${discountCode}`)
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {},
        }),
      });
    })
    .then(function(){
       window.location.href = '/checkout';       
    })
    .catch(function(error) {
      window.location.href = '/checkout';
      console.error('Error:', error);
    });
  }
}


$(document).on("click", ".login-class", function () {
  var link = $(this).attr("data-url");
  window.location.href = link;
});

/*********************** Start Discount Price On PDP for Customers Rewards *********************/
$("document").ready(function () {
  
  // $("body").on("click", ".protection_option_value label", function () {
  //   setTimeout(function () {
  //   if( $(".product-form__info-content .price.price--highlight").length > 0 ){
  //     var Priceget = $(
  //       ".product-form__info-content .price.price--highlight"
  //     ).html(); 
  //   }
  //   else{
  //     var Priceget = $(
  //       ".product-form__info-content .price-list .price"
  //     ).html();
  //     }
  //     var RewardPercentage = $(".reward-price").attr("data-percentage");
  //     RewardPercentage = parseInt(RewardPercentage);
  //     var PricegetGet = Priceget.replace("$", "");
  //     PricegetGet = PricegetGet.replace(",", "");
  //     Priceget = Priceget.replace("$", "");
  //     Priceget = Priceget.replace(",", "");
  //     Priceget = parseInt(Priceget);
  //     Priceget = Priceget * RewardPercentage;
  //     Priceget = Priceget / 100;
  //     var Discounted = PricegetGet-Priceget;
  //     Discounted = Discounted.toFixed(2);
  //     Discounted = "$" + Discounted;
  //     $(".reward-price .price-text").html(Discounted);
  //   }, 500);
  // });
  

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  $(".not-logged").click(function () {
    var url = window.location.href;
    setCookie("url", url, 365);
  });
  var URL = getCookie("url");
  $(".cooki-url").attr("value", URL);
  var afteLogin = window.location.href;
  if (afteLogin == URL) {
    setCookie("url", "https://www.tagourmet.ca/", 365);
  }
});

/*********************** End Discount Price On PDP for Customers Rewards *********************/

/*************************Start Gift Balance Script*******************/
$(document).ready(function(){
$(".check-bal-btn").click(function(){
  var GiftNumber = $(".gift-input-num").val();
  if(GiftNumber == ""){
    $(".error-gift-msg").show();
    $(".gift-value-out").hide();
    $(".gift-value-input").show();
  }
  else{
    $.ajax({
      url: "https://www.tagiftcards.com/api/giftcard_balance?giftcard_number="+GiftNumber,
      crossDomain: true,
      type: "POST",
      success: function(html){
        $(".error-gift-msg").hide();
       var GetPrice = (html['message']['balance']);
        GetPrice = "$"+GetPrice;
         var GetGiftId = (html['message']['giftcard_id']);
        $(".card-value").html(GetGiftId);
        $(".balance-value").html(GetPrice);
        $(".gift-value-out").show();
        $(".gift-value-input").hide();
        $(".gift-sec-title").html("YOUR e-GIFT CARD BALANCE");
      },
      error: function(error){
        $(".error-gift-msg").show();
        $(".gift-value-out").hide();
        $(".gift-value-input").show();
      	console.log(error,'error');
      }
    });
  }
});


$(".revert-back").click(function(){
      $(".gift-value-out").hide();
  $(".gift-value-input").show();
      $(".card-value").html("");
    $(".balance-value").html("");
  $(".error-gift-msg").hide();
  $(".gift-input-num").val("");
  $(".gift-sec-title").html("CHECK e-GIFT CARD BALANCE");
    
})  
})
/*************************End Gift Balance Script*******************/
// end
